import React, { useRef, useState, useEffect } from 'react';
import sendImage from '../../Assets/send.png';
import WordMovingAnimation from './WordMovingAnimation';
import { SectionWord, WorkWord } from './ProjectData';
import LazyImage from './LazyImage';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../lib/utils';

const HomeProjects = (props) => {
    const navigate = useNavigate();
    const elementRef = useRef(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    const isMobile = windowWidth <= 767;
    const isTablet = windowWidth > 767 && windowWidth <= 1023;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleProjectPortfolio = (projectId) => {
        navigate("/project/"+ projectId)
    }

    return (
        <div 
            ref={elementRef}
            className='homeProjectContainer'
        >
            <WordMovingAnimation dataArray={WorkWord} direction='right' className="wmat" />
            <WordMovingAnimation dataArray={SectionWord} direction='left'  className="wmab" />
            <div className={`homeProjectContent ${isMobile ? 'px-4 py-6' : isTablet ? 'px-8 py-10' : ''}`}>
                {props?.data?.map((project) => {
                    return (
                        <div 
                            id={project?.id} 
                            className={`h3_eachProject ${isMobile ? 'mb-16 p-4' : isTablet ? 'mb-24 p-6' : ''}`}
                            key={project?.id}
                        >
                            <div
                                className={cn(
                                "absolute inset-0",
                                "[background-size:15px_15px]",
                                "[background-image:radial-gradient(#d4d4d4_1px,transparent_1px)]",
                                "dark:[background-image:radial-gradient(#404040_1px,transparent_1px)]",
                                )}
                            />
                            <div className="pointer-events-none absolute rounded-[32px] inset-0 flex items-center justify-center bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)] dark:bg-black"></div>
                            <div className={`ep_includes ${isMobile ? 'flex-wrap' : ''}`}>
                                {project?.tags?.map((tag, index) => {
                                    return (
                                        <div 
                                            id={tag} 
                                            className={`mr-4 flex items-center ${isMobile ? 'mb-2' : ''}`}
                                            key={tag}
                                        >
                                            <div className={`ep_include font-satoshi ${isMobile ? 'text-sm py-1 px-2' : isTablet ? 'text-base' : ''}`}>
                                                {tag}
                                            </div>
                                            {index !== project?.tags?.length - 1 && <div className='include_dot' />}
                                        </div>
                                    )
                                })}
                            </div>
                            <div className={`${isMobile || isTablet ? 'flex flex-col' : 'flex justify-between'}`}>
                                <div className={`${isMobile ? 'w-full' : isTablet ? 'w-[60%]' : 'h3_eP_left'}`}>
                                    <div className={`h3_ep_title font-satoshi ${isMobile ? 'text-2xl leading-8 mt-4' : isTablet ? 'text-3xl leading-10 mt-6' : ''}`}>
                                        {project?.title}
                                    </div>
                                    <div className={`h3_ep_subText ${isMobile ? 'text-base leading-6 mt-3' : isTablet ? 'text-xl leading-7 mt-4' : ''}`}>
                                        {project?.infoText}
                                    </div>
                                    <div 
                                        style={{ zIndex: 1 }}
                                        className={`h3_ep_button font-satoshi ${isMobile ? 'text-base mt-6 mb-6' : isTablet ? 'text-lg mt-8' : ''}`} 
                                        onClick={() => handleProjectPortfolio(project?.projectPortfolioId)}
                                    >
                                        View Case Study
                                        <img 
                                            src={sendImage} 
                                            alt="send" 
                                            className={isMobile ? 'w-4 h-4 ml-2' : isTablet ? 'w-5 h-5 ml-2' : ''}
                                        />
                                    </div>
                                </div>
                                <div className={`${isMobile ? 'w-full h-[212px] overflow-hidden rounded-b-2xl' : isTablet ? 'w-[38%] h-[350px] mt-8' : 'h3_eP_right'}`}>
                                    {project?.imageUrl && (
                                        <LazyImage 
                                            key={project?.id} 
                                            src={project?.imageUrl} 
                                            alt={`Image ${project?.id}`}
                                            className={isMobile ? 'object-cover w-full h-full' : ''}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
};

export default HomeProjects;
